"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = require("@findify/sdk/lib/request");
exports.Request = request_1.Request;
exports.RequestBody = request_1.Body;
exports.RequestType = request_1.Type;
var response_1 = require("@findify/sdk/lib/response");
exports.ResponseBody = response_1.Body;
exports.ResponseMeta = response_1.Meta;
var Field;
(function (Field) {
    Field["Filters"] = "filters";
    Field["Query"] = "q";
    Field["Sort"] = "sort";
    Field["Offset"] = "offset";
    Field["Limit"] = "limit";
})(Field = exports.Field || (exports.Field = {}));
var Facets;
(function (Facets) {
    Facets["text"] = "text";
    Facets["category"] = "category";
    Facets["range"] = "range";
})(Facets = exports.Facets || (exports.Facets = {}));
//# sourceMappingURL=types.js.map